module.exports = __webpack_public_path__ + "media/images/gift-3e419c0b89cb54f968e46702e9b902a8.svg";